(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarBlockDateCreateController', WebinarBlockDateCreateController);

    WebinarBlockDateCreateController.$inject = ['$uibModalInstance','WebinarService', 'locations','date','calendar'];

    function WebinarBlockDateCreateController($uibModalInstance, WebinarService, locations, date, calendar) {
        var vm = this;
        vm.locations = locations;
        vm.reason = "";
        vm.checkedLocations = {};
        vm.date = date;
        vm.storeBlockDate = storeBlockDate;
        vm.cancel = cancel;

        function storeBlockDate() {
            vm.query = {};
            vm.query['reason'] = vm.reason;
            vm.query['locations'] = vm.checkedLocations;
            vm.query['date'] = vm.date;
            WebinarService.storeBlockDate(vm.query).then(function(response){
                cancel();
                vm.reason = "";
                vm.checkedLocations = {};
                alertify.notify('Block date successfully saved', 'success', 3);
                calendar.events = [];
                WebinarService.getBlockedDates().then(function(response){
                    angular.forEach(response.data,function(value){
                        addEvent(value);
                    });
                });
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function addEvent(data) {
            vm.date = new Date(data.start.replace(/-/g,"/"));
            calendar.events.splice(data.id,0,{
                id : data.id,
                title: data.reason,
                start: vm.date,
                date : data.start,
                allDay: true,
                className: ['openSesame']
            });
        }

        function activate() {
        }

        activate();
    }

})();